module.exports = __webpack_public_path__ + "static/media/cancer.5c4fc594.svg";